import { render, staticRenderFns } from "./swiper_edit.vue?vue&type=template&id=1896e463&scoped=true&"
import script from "./swiper_edit.vue?vue&type=script&lang=js&"
export * from "./swiper_edit.vue?vue&type=script&lang=js&"
import style0 from "./swiper_edit.vue?vue&type=style&index=0&id=1896e463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1896e463",
  null
  
)

export default component.exports